import {
    GET_GOLDEN_REFERRERS,
    GR_LOADING
} from "../actions/GoldenReferresActions"

const initialState = {
    goldenreferres: [],
    loading: true,
};

const GoldenReferresReducer = function(state = initialState, action){
    switch (action.type) {
        case GR_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_GOLDEN_REFERRERS: {
            return {
                ...state,
                goldenreferres: [...action.data],
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default GoldenReferresReducer;


